import { animBaseTypes } from '@/animations'
import { AnimBase } from '@/animations/types'
import { MEDIA } from '@spot'
import { useGSAPMedia } from '../use-gsap'

interface Props {
  ref: any
  tl: React.MutableRefObject<GSAPTimeline | gsap.core.Tween | null>
  anim?: AnimBase
  animVars?: GSAPTweenVars
  animScrollVars?: ScrollTrigger.Vars
}

const useAnimationsBase = ({ ...props }: Props) => {
  useGSAPMedia({
    media: MEDIA,
    scope: props?.ref,
    type: 'effect',
    callback: (_c) => {
      if (!props.anim) {
        return
      }
      animBaseTypes[props.anim]({
        tl: props.tl,
        ref: props?.ref,
        ctx: _c,
        animVars: props.animVars,
        animScrollVars: props.animScrollVars
      })
    }
  })
}

export default useAnimationsBase
